import { useState } from "react";
import { Upload } from "lucide-react";
import { Button } from "@/components/ui/Button";
import { FileDropZone } from "@/components/ui/FileDropZone";

export interface ResultUploadKind {
  key: string;
  label: string;
  /** Undefined = dowolny typ pliku. */
  accept?: string;
  multiple: boolean;
  /** True → upload idzie pod other_files (backend pomija białą listę rozszerzeń). */
  other?: boolean;
}

/**
 * Upload plików wynikowych zamówienia (sekcje „Pliki ze starostwa / z gminy") z wyborem
 * rodzaju: konkretne dokumenty (mapa, licencja/DOO, wypisy…) z ograniczonym typem pliku
 * oraz „Inne pliki" — dowolny format, wiele naraz (korespondencja, wezwania itp.).
 */
export function ResultFilesUpload({
  kinds,
  pending,
  onUpload,
}: {
  kinds: ResultUploadKind[];
  pending: boolean;
  onUpload: (files: File[], other: boolean, done: () => void) => void;
}) {
  const [kindKey, setKindKey] = useState(kinds[0]?.key ?? "");
  const [files, setFiles] = useState<File[]>([]);
  const kind = kinds.find((k) => k.key === kindKey) ?? kinds[0];
  if (!kind) return null;

  return (
    <div className="space-y-2">
      {kinds.length > 1 && (
        <div className="flex flex-wrap gap-1">
          {kinds.map((k) => (
            <button
              key={k.key}
              type="button"
              onClick={() => {
                setKindKey(k.key);
                setFiles([]);
              }}
              className={`px-2 py-1 border text-xs transition-colors ${
                k.key === kind.key
                  ? "border-[var(--color-primary)] text-[var(--color-primary)] bg-[var(--color-primary-dim)]"
                  : "border-[var(--color-border-strong)] text-[var(--color-text-secondary)] hover:border-[var(--color-primary)]"
              }`}
            >
              {k.label}
            </button>
          ))}
        </div>
      )}
      <FileDropZone
        files={files}
        onFilesChange={setFiles}
        multiple={kind.multiple}
        accept={kind.accept}
      />
      {files.length > 0 && (
        <Button
          size="sm"
          loading={pending}
          onClick={() => onUpload(files, !!kind.other, () => setFiles([]))}
        >
          <Upload size={13} className="mr-1" /> Wgraj ({files.length})
        </Button>
      )}
    </div>
  );
}
